import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ShieldCheck, Lock, ArrowLeft } from 'lucide-react';
import { PageHeader } from '../PageHeader';
import { AdminPage } from './AdminPage';
import { useApp } from '../store';
// Gate that keeps the intranet open to everyone while restricting the Site
// Admin panel to people with the marketing passcode. No login required.
export function AdminGate() {
  const {
    isAdmin
  } = useApp();
  if (isAdmin) return <AdminPage data-id="element-213" />;
  return <AdminUnlock data-id="element-214" />;
}
function AdminUnlock() {
  const {
    unlockAdmin
  } = useApp();
  const [code, setCode] = useState('');
  const [error, setError] = useState(false);
  const submit = (e: React.FormEvent) => {
    e.preventDefault();
    const ok = unlockAdmin(code);
    if (!ok) {
      setError(true);
      setCode('');
    }
  };
  return <>
      <PageHeader title="Site Administration" subtitle="Restricted to the marketing & communications team." data-id="element-215" />
      <div className="max-w-md" data-id="element-216">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="bg-white rounded-2xl border border-navy-100 p-8 text-center" data-id="element-217">
          <div className="w-14 h-14 rounded-2xl bg-navy-600 text-gold-400 flex items-center justify-center mx-auto mb-4" data-id="element-218">
            <ShieldCheck className="w-7 h-7" data-id="element-219" />
          </div>
          <h2 className="text-xl font-serif font-bold text-navy-900" data-id="element-220">
            Enter the marketing access code
          </h2>
          <p className="text-sm text-navy-500 mt-1 mb-6" data-id="element-221">
            The intranet is open to everyone, but publishing and configuration
            are limited to the marketing team.
          </p>
          <form onSubmit={submit} className="space-y-3 text-left" data-id="element-222">
            <label className="block" data-id="element-223">
              <span className="sr-only" data-id="element-224">Access code</span>
              <div className="relative" data-id="element-225">
                <Lock className="w-4 h-4 text-navy-400 absolute left-3 top-1/2 -translate-y-1/2 pointer-events-none" data-id="element-226" />
                <input type="password" autoFocus value={code} onChange={e => {
                setCode(e.target.value);
                setError(false);
              }} placeholder="Access code" className={`w-full pl-9 pr-3 py-2.5 rounded-lg bg-navy-50 border text-sm text-navy-900 focus:bg-white focus:outline-none focus:ring-2 focus:ring-gold-400/30 ${error ? 'border-red-400' : 'border-transparent focus:border-gold-400'}`} data-id="element-227" />
              </div>
            </label>
            {error && <p className="text-sm text-red-600" data-id="element-228">
                That code isn't right. Check with your marketing lead.
              </p>}
            <button type="submit" className="w-full px-5 py-2.5 text-sm font-bold text-navy-900 bg-gold-500 rounded-lg hover:bg-gold-400 transition-colors" data-id="element-229">
              Unlock Site Admin
            </button>
          </form>
          <Link to="/" className="inline-flex items-center gap-1.5 text-sm font-semibold text-navy-500 hover:text-navy-700 mt-5" data-id="element-230">
            <ArrowLeft className="w-4 h-4" data-id="element-231" /> Back to home
          </Link>
        </motion.div>
      </div>
    </>;
}